import React from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import { AccountTree, ChevronRight } from "@material-ui/icons";

import { useAdminSubaccountMemberships } from "src/components/LoggedInAdminProvider";
import PageTitle from "src/components/PageTitle";

const useStyles = makeStyles(() => ({
  listItemText: {
    paddingLeft: 12
  }
}));

function SubaccountLink({
  icon,
  title,
  href,
  note
}: {
  icon: JSX.Element;
  title: string;
  href: string;
  note?: string | JSX.Element;
}): JSX.Element {
  const classes = useStyles();

  return (
    <ListItem button component={Link} to={href}>
      <ListItemAvatar>{icon}</ListItemAvatar>
      <ListItemText
        className={classes.listItemText}
        primary={title}
        secondary={note}
      />
      <ListItemSecondaryAction>
        <ChevronRight />
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default function Subaccounts(): JSX.Element {
  const memberships = useAdminSubaccountMemberships()!;
  return (
    <Container>
      <PageTitle title="Subaccounts" />
      <List disablePadding>
        {memberships.map(membership => (
          <React.Fragment key={membership.id}>
            <Divider />
            <SubaccountLink
              icon={<AccountTree style={{ width: 42, height: 42 }} />}
              title={membership.subaccount.name}
              href={`/subaccounts/${membership.subaccount.id}/campaigns`}
              note={`Joined ${new Date(
                membership.createdAt
              ).toLocaleDateString()}`}
            />
          </React.Fragment>
        ))}

        <Divider />
      </List>
    </Container>
  );
}
